import React from "react";
import T from "prop-types";
import { Field } from "redux-form";
import { connect } from "react-redux";
import { Row, Col } from "react-bootstrap";
import * as actions from "MODULES/SalesOrders/actions";

import {
  form,
  Form as AppForm,
  CurrencyField
} from "MODULES/shared/components/Forms";

function Form(props) {
  return (
    <AppForm {...props}>
      <AppForm.Body>
        <Row>
          <Col md={6} mdOffset={3}>
            <Field
              name="outright_value"
              component={CurrencyField}
              label="Original Evaluation Estimate"
            />
          </Col>
        </Row>
      </AppForm.Body>
    </AppForm>
  );
}

Form.propTypes = {
  lineItem: T.shape({
    received: T.bool.required
  })
};

export default connect(undefined, (dispatch, ownProps) => ({
  onSubmit: data =>
    dispatch(actions.createInternalOutrightSale(ownProps.lineItem.id, data))
}))(
  form({
    form: "internalOutrightSaleForm"
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Body/LineItems/InternalOutrightSale/Form.jsx